// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2eGpr","footer":"ModalInfo_footer__1uKys"};